export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxOloc5yjTjQJElti5.176f34fd.woff2";